var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGetStarted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0.8C8 0.358172 8.35817 0 8.8 0H15.2C15.6418 0 16 0.358172 16 0.8C16 1.24183 15.6418 1.6 15.2 1.6H8.8C8.35817 1.6 8 1.24183 8 0.8Z",
    fill: "#232D54"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.56569 6.43434C6.25327 6.74676 5.74674 6.74676 5.43432 6.43434L4.56569 5.56571C4.25327 5.25329 4.25327 4.74676 4.56569 4.43434C4.87811 4.12192 5.38464 4.12192 5.69706 4.43434L6.56569 5.30297C6.87811 5.61539 6.87811 6.12192 6.56569 6.43434Z",
    fill: "#232D54"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22.4C7.36081 22.4 3.6 18.6392 3.6 14C3.6 9.36081 7.36081 5.6 12 5.6C16.6392 5.6 20.4 9.36081 20.4 14C20.4 18.6392 16.6392 22.4 12 22.4ZM12 24C6.47715 24 2 19.5228 2 14C2 8.47715 6.47715 4 12 4C17.5228 4 22 8.47715 22 14C22 19.5228 17.5228 24 12 24Z",
    fill: "#232D54"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 0.8C16 0.358172 15.6418 0 15.2 0H8.8C8.35817 0 8 0.358172 8 0.8C8 1.24183 8.35817 1.6 8.8 1.6H15.2C15.6418 1.6 16 1.24183 16 0.8Z",
    fill: "#232D54"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 5V1L11 1V5H13Z",
    fill: "#232D54"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4343 6.43434C17.7467 6.74676 18.2533 6.74676 18.5657 6.43434L19.4343 5.56571C19.7467 5.25329 19.7467 4.74676 19.4343 4.43434C19.1219 4.12192 18.6154 4.12192 18.3029 4.43434L17.4343 5.30297C17.1219 5.61539 17.1219 6.12192 17.4343 6.43434Z",
    fill: "#232D54"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5518 9.99797L12.9979 13.9468C12.7273 14.2475 12.2598 14.2598 11.9737 13.9737C11.7082 13.7082 11.6969 13.2812 11.9482 13.002L15.5021 9.05321C15.7728 8.7525 16.2402 8.74021 16.5263 9.02628C16.7918 9.29184 16.8031 9.71881 16.5518 9.99797Z",
    fill: "#232D54"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetStarted);
export default __webpack_public_path__ + "static/media/get_started.bf6718dcffa8f547de2dd6d232085303.svg";
export { ForwardRef as ReactComponent };